<template>
    <div class="ag-theme-alpine custom-grid-theme" style="height: 100%;">
        <AgGridVue
            class="ag-theme-alpine"
            style="width: 100%;height: 100%;"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :defaultColDef="defaultColDef"
            :singleClickEdit="false"
            :gridOptions="gridOptions"
            :stopEditingWhenCellsLoseFocus="true"
            :context="{ componentParent: this, currency: this.$store.state.currency.symbol }"
            @grid-ready="onGridReady"
        />
    </div>
</template>

<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
// import AgAutoComplete from '@/views/dashboard/components/general/patial/Ag-autocomplete.vue'
// import AgMoney from '@/views/dashboard/components/general/Money/Ag-money.vue'
// import AgDatePicker from '@/views/dashboard/components/general/datePicker/Ag-datePicker.vue'
import AgRemove from '@/views/dashboard/pages/invoice/CashRegister/partial/Ag-remove.vue'
// import AgDiscount from '@/views/dashboard/components/general/Money/Ag-discount.vue'

export default {
  data () {
    return {
      defaultColDef: {
        flex: 1,
        resizable: true
      },
      gridOptions: {
        enableRtl: true,
        context: { componentParent: this },
        rowDragManaged: true
      },
      gridApi: null
    }
  },
  components: {
    AgGridVue: Vue.extend(AgGridVue),
    // AgAutoComplete: Vue.extend(AgAutoComplete),
    // AgMoney: Vue.extend(AgMoney),
    // AgDatePicker: Vue.extend(AgDatePicker),
    AgRemove: Vue.extend(AgRemove),
    // AgDiscount: Vue.extend(AgDiscount)
  },
  methods: {
    onGridReady (params) {
      this.gridApi = params.api
    }
  },
  beforeMount () {
    this.rowData = [
      { product: '', count: '', unit: '', fee: '', discount: '', sum: '', actions: '' },
      { product: '', count: '', unit: '', fee: '', discount: '', sum: '', actions: '' }
    ]
    this.columnDefs = [
      {
        headerName: '#',
        valueGetter: 'node.rowIndex + 1',
        pinned: 'right',
        width: 30,
        minWidth: 30,
        maxWidth: 30,
        resizable: false
      },
      {
        headerName: this.$t('product-name'),
        field: 'product',
        editable: true,
        cellEditor: 'AgAutoComplete',
        cellEditorPopup: false,
        cellEditorParams: (params) => ({
          type: 'given',
          newBtn: true,
          rules: [v => !!v || this.$t('is-required')],
          ref: 'refProduct' + params.node.rowIndex
        })
      },
      {
        headerName: this.$t('count'),
        suppressHtmlEscaping: true,
        field: 'count',
        cellEditor: 'agNumberCellEditor',
        editable: true,
        valueParser: params => {
          const val = Number(params.newValue)
          return isNaN(val) ? params.oldValue : val
        },
        onCellKeyPress: event => {
          const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
          if (!allowedKeys.includes(event.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
            event.preventDefault()
          }
        }
      },
      {
        headerName: this.$t('unit'),
        field: 'unit',
        editable: true,
        cellEditor: 'AgAutoComplete',
        cellEditorPopup: false,
        cellEditorParams: (params) => ({
          type: 'detail',
          newBtn: true,
          ref: 'refFin5' + params.node.rowIndex
        })
      },
      {
        headerName: this.$t('fee'),
        field: 'fee',
        editable: true,
        cellEditor: 'AgMoney',
        cellEditorParams: function (params) {
          const vm = params.context.componentParent
          return {
            currencySymbol: vm.$store.state.currency.symbol,
            precision: 0
          }
        },
        valueFormatter: params => {
          const vm = params.context.componentParent
          const currency = vm.$store.state.currency.symbol || ''
          if (params.value == null) return '0 ' + currency
          const formatted = new Intl.NumberFormat().format(params.value)
          return formatted + ' ' + currency
        },
        valueParser: params => {
          const number = Number(params.newValue.toString().replace(/,/g, ''))
          return isNaN(number) ? 0 : number
        }
      },
      {
        headerName: this.$t('discount'),
        field: 'discount',
        editable: true,
        cellEditor: 'AgDiscount',
        cellEditorParams: function (params) {
          const vm = params.context.componentParent
          return {
            currencySymbol: vm.$store.state.currency.symbol,
            precision: 0,
            baseAmount: params.data.fee
          }
        },
        cellRenderer: params => {
          const vm = params.context.componentParent
          const currency = vm.$store.state.currency.symbol || ''
          const amount = params.value || 0
          const fee = params.data.fee || 1
          const percent = Math.round((amount / fee) * 100)
          const formattedAmount = new Intl.NumberFormat().format(amount)

          // Return HTML
          return `
          <div class="d-flex align-center justify-center gap-2">
            <div 
              class="d-flex justify-center align-center" 
              style="border-left: 1px solid silver;padding-left: 5px;flex: 8;"
            >
              <span>${formattedAmount} ${currency}</span>
            </div>
            <div 
              class="d-flex justify-center align-center"
              style="flex: 2;"
            >
              <span>${percent}%</span>
            </div>
          </div>
          `
        },
        valueParser: params => {
          const number = Number(params.newValue.toString().replace(/,/g, ''))
          return isNaN(number) ? 0 : number
        }
      },
      {
        headerName: this.$t('sum'),
        field: 'sum',
        editable: true,
        cellEditor: 'AgMoney',
        cellEditorParams: function (params) {
          const vm = params.context.componentParent
          return {
            currencySymbol: vm.$store.state.currency.symbol,
            precision: 0
          }
        },
        valueFormatter: params => {
          const vm = params.context.componentParent
          const currency = vm.$store.state.currency.symbol || ''
          if (params.value == null) return '0 ' + currency
          const formatted = new Intl.NumberFormat().format(params.value)
          return formatted + ' ' + currency
        },
        valueParser: params => {
          const number = Number(params.newValue.toString().replace(/,/g, ''))
          return isNaN(number) ? 0 : number
        }
      },
      {
        headerName: '',
        field: 'actions',
        cellRenderer: 'AgRemove',
        headerComponent: 'AgRemove',
        width: 40,
        minWidth: 40,
        maxWidth: 40,
        resizable: false,
        cellClass: 'center-cell'
      }
    ]
  }
}
</script>

<style>
.ag-cell-value.ag-cell {
  font-size: 9pt;
}
.ag-theme-alpine .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {
    font-size: 8.5pt;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-left: none;
}
.ag-pinned-right-header .ag-header-cell-label,
.ag-header-cell:not(.ag-header-cell-auto-height) .ag-header-cell-comp-wrapper {
    justify-content: center;
}
.ag-header-cell.ag-column-first.ag-header-cell-sortable.ag-focus-managed {
    padding: 0;
}
.center-cell {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ag-input-field-input.ag-checkbox-input{
  cursor: pointer;
}
.ag-theme-alpine .ag-header-cell, .ag-theme-alpine .ag-header-group-cell {
  padding: 10px;
}
.ag-theme-alpine .ag-rtl .ag-selection-checkbox {
  margin-left: 0;
}
.ag-pinned-right-header .ag-header-row.ag-header-row-column .ag-header-cell.ag-focus-managed:nth-child(2) {
  display: none;
}
.ag-pinned-right-header .ag-header-row.ag-header-row-column .ag-header-cell.ag-focus-managed:nth-child(1),
.ag-pinned-right-header .ag-header-row.ag-header-row-column .ag-header-cell.ag-focus-managed:nth-child(3) {
  overflow: visible;
}
.ag-theme-alpine .ag-rtl .ag-has-focus .ag-pinned-right-cols-container .ag-cell-focus.ag-cell-focus:not(.ag-cell-range-selected) {
  border: 1px solid transparent;
}
.ag-theme-alpine .ag-header-cell-resize::after {
  display: none;
}
.ag-theme-alpine .ag-pinned-right-header {
  border-left: none;
}
.ag-theme-alpine .ag-pinned-right-cols-container .ag-row .ag-cell {
  border-right: none;
}
.ag-theme-alpine .ag-pinned-right-header .ag-header-row.ag-header-row-column .ag-header-cell:nth-child(1) {
  border-right: none;
}
.ag-theme-alpine .ag-row {
  border-bottom: 1px solid #d3d3d3;
}
.ag-theme-alpine .ag-cell {
  border-right: 1px solid #d3d3d3;
}
.ag-theme-alpine .ag-header-cell {
  border-right: 1px solid #b0b0b0;
}
.ag-row-odd  {
  background-color: #c0c0c033 !important;
}
.ag-header {
  background-color: #c0c0c0bd !important;
}
.ag-cell-label-container {
  padding: 0;
}
.ag-header-cell,
.ag-header-row.ag-header-row-column {
  height: 35px !important;
}
.ag-header {
  height: 35px !important;
  min-height: 35px !important;
}
.ag-header-cell-text {
  font-size: 9pt;
}
.ag-body-horizontal-scroll,
.ag-body-vertical-scroll {
  display: none !important;
}
</style>
